<div class="scroll-xx saving--pre" [class.saving]="loading">
  <table class="table {{classes}}" [class.table--change-sequence]="changeSequence">
    <thead>
      <tr [class.no-pointer-events]="changeSequence">
        @for (head of heads; track head) {
          <th [ngStyle]="{'min-width' : head.code === 'actions' ? '38px' : 'unset', 'width' : head.width ? head.width : 'auto'}" [class.sortable]="head.sortable" (click)="head.sortable && clickSort(head)"><div class="position-relative" [ngClass]="getSortingClass(head)">{{head.name}}@if (head.sortable) {
            <i [class.saving]="changeSequence" [ngClass]="getSortingClass(head)"></i>
          }</div></th>
        }
      </tr>
    </thead>
    @if (ready) {
      <tbody id="sortable">
        @for (item of data; track identify($i, item); let $i = $index) {
          <tr [class.active]="item.trActive" [class.clickable]="clickable && !changeSequence" class="sortable-handle">
            @for (head of heads; track identify($index, head)) {
              <td (click)="clickData.emit({item: item, head: head.code})" [class.td--mw-0]="item[head.code]?.mw0" [class.shrink]="item[head.code] && item[head.code].type === 'actions'" [class.vertical-middle]="item[head.code] && item[head.code].type === 'checkbox'" [class.linethrough]="item && item.linethrough && item[head.code] && head.code !== 'actions'" >
                <!-- default -->
                @if (!item[head.code] || !item[head.code].type) {
                  <span [class.data-ellipsis]="item[head.code]?.ellipsis">{{head.code === 'empty' ? '' : item[head.code] | display}}</span>
                }
                <!-- icon -->
                @if (item[head.code] && item[head.code].type === 'icon') {
                  <i class="im-icon {{item[head.code]?.classList}}" [style.background-image]="'url(' + item[head.code]?.iconPath + ')'" [class.asset-icon]="item[head.code]?.iconPath"></i>
                }
                <!-- default type (with props) -->
                @if (item[head.code] && item[head.code].type === 'default') {
                  <div [class.data-ellipsis-parent]="item[head.code]?.ellipsis"><span [class.data-ellipsis]="item[head.code]?.ellipsis" [ngStyle]="{'width' : item[head.code]?.cellMaxWidth ? item[head.code]?.cellMaxWidth : 'unset' }" [class]="item[head.code].classList" [ngClass]="item[head.code].color ? 'text-color-' + item[head.code].color : ''">{{item[head.code].value | display}}</span></div>
                }
                <!-- Pagetitle -->
                @if (item[head.code] && item[head.code].type === 'pageTitle') {
                  <div [class.data-ellipsis-parent]="item[head.code]?.ellipsis">
                    @if (item.isSubPage && item.title) {
                      <i class="im-icon-arrow-newline" style="padding-right: 8px;"></i>
                    }
                    <span [class.data-ellipsis]="item[head.code]?.ellipsis" [ngStyle]="{'width' : item[head.code]?.cellMaxWidth ? item[head.code]?.cellMaxWidth : 'unset' }" [class]="item[head.code].classList" [ngClass]="item[head.code].color ? 'text-color-' + item[head.code].color : ''">{{item[head.code].value | display}}</span>
                  </div>
                }
                <!-- titleSubtitle -->
                @if (item[head.code] && item[head.code].type === 'titleSubtitle') {
                  <div class="d-flex flex-column">
                    <span class="text-color title">
                      {{item[head.code].title | display}}
                      @if (item[head.code] && item[head.code].stamps) {
                        <div class="d-inline-block" [class.app-tooltip-wrap]="item[head.code].tooltip">
                          @for (stamp of item[head.code].stamps; track stamp) {
                            <span class="stamp mr-xxs" [class]="stamp.classList">
                              {{stamp.value}}
                            </span>
                          }
                          @if (item[head.code].tooltip) {
                            <div class="app-tooltip app-tooltip-default-centered">{{item[head.code].tooltip}}</div>
                          }
                        </div>
                      }
                    </span>
                    <span class="fontsize-s" style="margin-top: 0px;">
                      {{item[head.code].subtitle | display}}
                      @if (item[head.code] && item[head.code].stampsSubtitle) {
                        <div class="d-inline-block" [class.app-tooltip-wrap]="item[head.code].tooltipSubtitle">
                          @for (stamp of item[head.code].stampsSubtitle; track stamp) {
                            <span class="stamp" [class]="stamp.classList">
                              {{stamp.value}}
                            </span>
                          }
                          @if (item[head.code].tooltipSubtitle) {
                            <div class="app-tooltip app-tooltip-default-centered">{{item[head.code].tooltipSubtitle}}</div>
                          }
                        </div>
                      }
                      @if (item[head.code] && item[head.code].afterSubtitle) {
                        {{item[head.code].afterSubtitle}}
                      }
                    </span>
                  </div>
                }
                <!-- avatar -->
                @if (item[head.code] && item[head.code].type === 'avatar') {
                  <app-avatar [user]="item[head.code].user" [image]="item[head.code].image" [title]="item[head.code].title" [subtitle]="item[head.code].subtitle" size="40" fontSize="14"></app-avatar>
                }
                <!-- arrayShowMore -->
                @if (item[head.code] && item[head.code].type === 'arrayShowMore') {
                  <app-arr-show-more
                    [items]="item[head.code].values"
                    [showAmount]="item[head.code].showAmount"
                  ></app-arr-show-more>
                }
                <!-- checkmark -->
                @if (item[head.code] && item[head.code].type === 'checkmark') {
                  <div class="checkmark">
                    @if (item[head.code].checked) {
                      <i class="im-icon im-icon-check-round-filled" style="color: #21A054;"></i>
                    }
                    @if (!item[head.code].checked) {
                      <i class="im-icon im-icon-check-round-filled" style="background-color: #D7DADD; border-radius: 100px; color: #D7DADD;" ></i>
                    }
                  </div>
                }
                <!-- checkbox -->
                @if (item[head.code] && item[head.code].type === 'checkbox') {
                  <button (click)="toggleCheckbox($event, item, head.code)" class="checkbox" [class.disabled]="disabled" [class.active]="item[head.code].value">
                    <div class="fake-checkbox"></div>
                  </button>
                }
                <!-- ts -->
                @if (item[head.code] && item[head.code].type === 'ts') {
                  <span style="white-space: nowrap;">{{item[head.code].ts | formatTs: item[head.code].format}}</span>
                }
                <!-- html -->
                @if (item[head.code] && item[head.code].type === 'html') {
                  <span [innerHTML]="item[head.code].value | safe : 'html'" [class.data-ellipsis]="item[head.code]?.ellipsis"></span>
                }
                <!-- app-button -->
                @if (item[head.code] && item[head.code].type === 'app-button') {
                  <app-button classes="{{item[head.code].actions?.classes}}" text="{{item[head.code].actions?.text}}"></app-button>
                }
                <!-- actions -->
                @if (item[head.code] && item[head.code].type === 'actions') {
                  @if (!changeSequence) {
                    @if (item[head.code].actions && item[head.code].actions.length) {
                      <div class="action-button d-flex align-items-center actions position-relative" (click)="helper.actionIndex == $i ? setActionIndex(null) : setActionIndex($i); $event.stopPropagation();" appClickOutside (clickOutside)="setActionIndex(null); clickOutsideActions()">
                        <i class="im-icon im-icon-actions"></i>
                        <app-popover [open]="helper.actionIndex === $i" positionClass="left" (click)="setActionIndex(null); $event.stopPropagation();">
                          <ul (click)="setActionIndex(null)">
                            @for (action of item[head.code].actions; track identify($index, action)) {
                              <li class="position-relative" appClickOutside (clickOutside)="popoverHelper = null" (click)="action.confirmDelete ? $event.stopPropagation() || popoverHelper = 'delete_' + $i : clickAction.emit({item: item, action: action.code});" [ngClass]="action.class || ''">
                                @if (action.icon) {
                                  <i class="im-icon im-icon-{{action.icon}}"></i>
                                }
                                {{action.name}}
                                @if (action.confirmDelete) {
                                  <app-confirm-delete [title]="action?.title" [descr]="action?.descr" (confirm)="clickAction.emit({item: item, action: action.code}); dismissPopover(); setActionIndex(null);" (cancel)="dismissPopover()" [open]="popoverHelper === 'delete_' + $i" positionClass="left"></app-confirm-delete>
                                }
                              </li>
                            }
                          </ul>
                        </app-popover>
                      </div>
                    }
                  } @else {
                    <div class="change-sequence-icon-wrap"><i class="im-icon im-icon-drag-and-drop"></i></div>
                  }
                }
              </td>
            }
          </tr>
        }
        @if (canAddRows) {
          <tr>
            @for (head of heads; track head) {
              @if (head.canAddField) {
                <td>
                  <app-field-text
                    [model]="addRowFormSTR[head.code]"
                    (modelChange)="addRowFormSTR[head.code] = $event;"
                    label=""
                    [error]=""
                    [placeholder]="head.name">
                  </app-field-text>
                </td>
              }
            }
            <td>
              <button (click)="addRow(addRowFormSTR)" class="button default"><i class="im-icon im-icon-plus"></i>Voeg toe</button>
            </td>
          </tr>
        }
      </tbody>
    }
    <!-- shimmer -->
    @if (!ready) {
      <tbody class="shimmer-body">
        @for (item of shimmerRows; track item) {
          <tr>
            <td [attr.colspan]="heads.length"><app-shimmer></app-shimmer></td>
          </tr>
        }
      </tbody>
    }
  </table>
</div>
<!-- emptystate -->
@if (!loading && data && !data.length && emptyState) {
  <div class="pl-xs pr-xs mt-s">
    <app-empty-state [value]="emptyState"></app-empty-state>
  </div>
}
<!-- pagination / export -->
@if (data && data.length) {
  <div class="row mt-l">
    <div class="col-md-4">
      <div class="d-flex justify-content-end">
        <!--  -->
      </div>
    </div>
    <div class="col-md-4">
      @if (totalRows > RPP) {
        <div class="d-flex justify-content-center">
          <app-pagination
            [RPP]="RPP"
            [startRow]="startRow"
            [totalRows]="totalRows"
            (startRowChange)="startRowChange.emit($event)">
          </app-pagination>
        </div>
      }
    </div>
    <div class="col-md-4 d-flex flex-row align-items-center">
      @if (exportLabel) {
        <div class="d-flex w-100 justify-content-end">
          <button (click)="clickExport.emit()" [class.disabled]="exportBusy" class="button-link fontsize-s export-btn">
            @if (exportBusy) {
              <app-inline-spinner class="mr-xxxs"></app-inline-spinner>
            } @else {
              <i class="im-icon im-icon-download"></i>
            }
            <span>{{exportLabel}}</span>
          </button>
        </div>
      }
    </div>
  </div>
}